import http from './http';

/**
 * GPA Calculator Revamp v1.1 (ClickUp #86ak9ab4g) — Step 5: client for the new
 * read-only calculator endpoints added in Step 4 (`gpa-calculator.controller.ts`
 * in master-be). Distinct from `gpaforecast.services.ts`, which still talks to
 * the original `/api/gpa-forecast/*` endpoints used by the existing table UI —
 * that path is untouched by this file.
 */
const gpaCalculatorServices = {
  /** POST /api/gpa/calculate — all 4 modes + per-school + auxiliary + per-mode contributing-course breakdown. */
  async calculate(studentId: any) {
    const body = { student_id: Number(studentId ?? 0) };
    const res = await http.post('api/gpa/calculate', body);
    return res;
  },

  /**
   * POST /api/gpa/calculate-forecast — same as calculate(), but accepts a
   * planned-grade overlay (DevSpec Section 5 / Step 6 what-if toggles).
   * plannedGrades: [{ gpa_forecast_id, term, grade }, ...]
   */
  async calculateForecast(studentId: any, plannedGrades: { gpa_forecast_id: number; term: string; grade: string }[] = []) {
    const body = {
      student_id: Number(studentId ?? 0),
      planned_grades: plannedGrades,
    };
    const res = await http.post('api/gpa/calculate-forecast', body);
    return res;
  },
};

export default gpaCalculatorServices;
